<template>
    <div>
        <div class="row mb-md-5 mb-4 mt-4 align-items-center">
            <div class="col">
                <h1 class="mb-0">Оформление заказа</h1>
            </div>
            <div class="col-auto" v-if="order">
                <div class="d-md-inline-block d-none">Время на оформление:</div>
                <div class="d-inline-block countdown ml-2">
                    <span v-if="checkouttime > 0">{{ minutes }}:{{ seconds }}</span>
                    <span v-if="checkouttime <= 0">истекло</span>
                </div>
            </div>
        </div>

        <div v-if="order">

            <div class="form-group">
                <label class="label-ch" for="email-ch">Email:</label>
                <div class="row align-items-center">
                    <div class="col-md-7 col-12">
                        <input type="email" id="email-ch" class="form-control" v-model="form.email"/>
                    </div>
                    <div class="col-md-5 col-12">
                        <div class="note-ch">На данный электронный адрес будут отправлены билеты после оплаты.</div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="label-ch" for="phone-ch">Телефон:</label>
                <div class="row align-items-center">
                    <div class="col-md-7 col-12">
                        <the-mask mask="+7(###)#######"
                                  id="phone-ch"
                                  class="form-control"
                                  placeholder="+7(7xx)xxxxxxx"
                                  v-model="form.phone"
                                  :masked="true"/>
                        <!--                        <input type="text" id="phone-ch" class="form-control" v-model="form.phone"/>-->
                    </div>
                    <div class="col-md-5 col-12">
                        <div class="note-ch">Мобильный телефон, по которому мы сможем с Вами связаться.</div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <label class="label-ch" for="name-ch">Имя:</label>
                <div class="row align-items-center">
                    <div class="col-md-7 col-12">
                        <input type="text" id="name-ch" class="form-control" v-model="form.name"/>
                    </div>
                    <div class="col-md-5 col-12">
                        <div class="note-ch">Данное имя будет указано на билете.</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mt-5 pt-3 small text-muted text-right">
            <div class="mb-2">Системы процессинга платежей:</div>
            <div class="row align-items-end justify-content-end">
                <div class="col-auto">
                    <img src="/images/epay.png" class="" alt="epay"/>
                </div>
                <div class="col-auto">
                    <img src="/images/kaspi_logo.svg" alt="kaspi"/>
                </div>
            </div>
        </div>

        <div class="modal" id="pay-method-modal" role="dialog" aria-labelledby="pay-method-modal-label" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Выберите метод оплаты</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <a class="d-block btn btn-themed btn-themed-secondary" @click="proceedToPay('card')">Оплатить картой любого банка</a>
                        <a class="d-block mt-3 pointer btn-kaspi" @click="proceedToPay('kaspi')">
<!--                            <img src="/images/kaspi.svg" class="img-fluid" alt="kaspi"/>-->
                            Оплатить QR с <img src="/images/kaspi_logo_w.svg" alt="kaspi"/>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <KaspiQR :kaspiQRData="kaspiQRData" :redirectUrl="redirectUrl"/>

    </div>
</template>

<script>
import { mapState } from 'vuex'
import { TheMask } from 'vue-the-mask'
import EventBus from '../../../event-bus'
import moment from 'moment'
import KaspiQR from "./KaspiQR"

export default {
    name: "Checkout",
    components: {
        KaspiQR,
        TheMask
    },
    computed: {
        ...mapState(['cart','timetable', 'order','user','checkouttime']),
        minutes () {
            return String(Math.floor(this.checkouttime / 60)).padStart(2, '0')
        },
        seconds () {
            return String(this.checkouttime % 60).padStart(2, '0')
        }
    },
    created() {
        this.$store.commit('setStep', 4)
        if(!this.order) {
            this.loadOrder()
        }
        EventBus.$on('fillOrder',this.choosePayMethod)
        this.populateFromUser()
        this.launchTimer()
    },
    methods: {
        launchTimer() {
            if(this.order) {
                this.countdown()
                this.timer = setInterval(this.countdown, 1000)
            }
        },
        loadOrder() {
            window.loaderIcon()
            axios.get(`/api/order/${this.$route.params.id}/${this.$route.params.hash}`).then(res => {
                let order = res.data.order
                this.$store.commit('setOrder', order)
                this.$store.commit('setUser', res.data.user)
                this.$store.commit('setTimetable', order.timetable)
                order.order_items.forEach(item => {
                    let sign = "+"
                    let ticket = {
                        seat_id:        item.seat_id,
                        section_id:     item.section_id,
                        row:            item.row,
                        seat:           item.seat,
                        price:          item.price,
                        section_name:   item.section ? item.section.title : {}
                    }
                    this.$store.commit('updateCart', { sign, ticket })
                })
                this.form.name = order.name
                this.form.email = order.email
                this.form.phone = order.phone
                if(!order.name) {
                    this.populateFromUser()
                }
                this.launchTimer()
            })
        },
        populateFromUser() {
            if(this.user) {
                this.form.name  = this.user.name
                this.form.email = this.user.email
                this.form.phone = this.user.phone
            }
        },
        choosePayMethod() {
            if(this.order && this.order.pay_url) {
                window.location = this.order.pay_url
                return
            }
            $('#pay-method-modal').modal()
        },
        proceedToPay(pay_system) {
            this.form.pay_system = pay_system
            $('#pay-method-modal').modal('hide')
            this.$store.commit('setIsInPaymentProcess', true)
            this.orderFill()
        },
        orderFill() {
            if(this.order.pay_url) {
                window.location = this.order.pay_url
                return
            }
            window.loaderIcon()
            axios.post(`/api/order/${this.order.id}/${this.order.hash}/fill`, {
                ...this.form,
                timetable_id: this.timetable.id
            }).then(res => {
                let d = res.data
                if(d && d.success && d.redirect) {
                    window.location = d.redirect
                    return
                }
                if(d && d.error) {
                    window.noty(d.error,'error')
                    return
                }
                if(d && d.success && d.epay) {
                    this.redirectUrl = d.redirectUrl
                    this.initEpay(d.epay)
                    return
                }
                if(d && d.success && d.kaspi) {
                    this.kaspiQRData = d.kaspi
                    this.redirectUrl = d.redirectUrl
                    this.$nextTick(() => {
                        $('#kaspi-qr-modal').modal();
                    })
                    return
                }
                window.noty('Что-то пошло не так','error')
            })
        },
        cancelOrder(reload = false) {
            window.loaderIcon()
            axios.delete(`/api/order/${this.order.id}/${this.order.hash}`).then(res => {
                this.$router.push('/')
                if(reload) location.reload()
            })
        },
        countdown() {
            if(!this.order) return
            let now = moment(new Date())
            let end = moment(this.order.created_at)
            this.$store.commit('setCheckoutTime', Math.round(this.timeToCheckout - moment.duration(now.diff(end)).asSeconds()))
            if(this.checkouttime <= 0 && this.timer) {
                clearInterval(this.timer)
                // this.cancelOrder(true)
                this.$router.push('/')
                location.reload()

            }
        },
        initEpay(auth) {
            var paymentObject = {
                invoiceId: this.order.id,
                backLink: this.redirectUrl,
                failureBackLink: this.redirectUrl,
                postLink: this.redirectUrl,
                failurePostLink: this.redirectUrl,
                language: "RU",
                description: "Покупка билетов в САЦ",
                accountId: "SATSTHEATRE",
                terminal: "8501abec-b2d9-4fea-a8e7-18546497d592",
                amount: this.order.price,
                currency: "KZT",
                cardSave: true  //Параметр должен передаваться как Boolean
            };
            paymentObject.auth = auth;
            halyk.showPaymentWidget(paymentObject, (res) => {
                this.$store.commit('setActionsBlock', true)
                if(res.success) {
                    window.location = this.redirectUrl
                } else {
                    location.reload()
                }
            })
        }
    },
    data() {
        return {
            form: {
                name: '',
                email: '',
                phone: '',
                pay_system: 'card',
            },
            timeToCheckout: 10 * 60,
            timer: null,
            kaspiQRData: null,
            redirectUrl: null
        }
    },
    metaInfo() {
        return {
            title: 'Оформление заказа',
            meta: []
        }
    }
}
</script>

<style scoped lang="scss">
.btn-themed-secondary {
    padding: 7px 14px;
    text-transform: none;
    border-radius: 6px;
}
.btn-kaspi {
    background: #f14635;
    color: #fff;
    line-height: 40px;
    display: block;
    text-align: center;
    border-radius: 6px;
    &:hover {
        text-decoration: none;
    }
    img {
        position: relative;
        top: -2px;
        left: 4px;
    }
}
</style>
